import { useEffect } from 'react';

// Clears the flag on unmount so a closing form can't leave the parent blocked
export default function useReportSaving(
  isSaving: boolean,
  onSavingChange?: (isSaving: boolean) => void,
) {
  useEffect(() => {
    onSavingChange?.(isSaving);

    return () => onSavingChange?.(false);
  }, [isSaving, onSavingChange]);
}
